import React from 'react';
import { listTypes, useMatchData } from "../../utils";
import { composeGeoLocatedProviders } from "../../../shared/utils";
import { useReactAppState } from "../../../shared/containers/utils";

const TvStreaming = () => {
  const { location } = useReactAppState();
  const { mediaProviders, listType } = useMatchData();
  if (listType !== listTypes.tv || !mediaProviders) {
    return null;
  }

  const { country } = location || {};
  const { streaming, national, radio } = composeGeoLocatedProviders(mediaProviders, country);

  const { homeLinear, awayLinear, homeStreaming, awayStreaming, clubLinear, clubStreaming, clubRadio } = mediaProviders || {};

  const mergedProviders = [
    ...national,
    ...streaming,
    ...radio,
    ...(homeLinear != null ? homeLinear : []),
    ...(awayLinear != null ? awayLinear : []),
    ...(homeStreaming != null ? homeStreaming : []),
    ...(awayStreaming != null ? awayStreaming : []),
    ...(clubLinear != null ? clubLinear : []),
    ...(clubStreaming != null ? clubStreaming : []),
    ...(clubRadio != null ? clubRadio : []),
  ];

  const showBroadcasters = mergedProviders && mergedProviders.length > 0;

  return (
    <ul className="mls-o-match-strip__tv-streaming-provider-list">
      {
        showBroadcasters
          ? mergedProviders.map((provider, index) => {
            const { broadcasterName, broadcasterTypeLabel } = provider || {};

            return (
              broadcasterName != null && broadcasterTypeLabel != null
                ? (
                  <li key={`${provider}-${index}`} className="mls-o-match-strip__tv-streaming-provider-item">
                    <span className="mls-o-match-strip__tv-streaming-provider-label">{provider.broadcasterTypeLabel}</span>
                    <span className="mls-o-match-strip__tv-streaming-provider">{provider.broadcasterName}</span>
                  </li>
                ) : null
            );
          })
          : null
      }
    </ul>
  );
};

export default TvStreaming;
